import client from '../api/client.ts';
import { ep } from '../api/endpoints.ts';
import { hydrateCurrentUserContext, setSession } from '../contexts/AuthContext.tsx';

export async function login(email: string, password: string): Promise<void> {
  const res = await client.post(ep.authLogin, { email, password }, { withCredentials: true });
  const token = res.data?.accessToken || res.data?.access_token || res.data?.token;
  if (!token) {
    // eslint-disable-next-line no-console
    console.error('Login API response missing accessToken field', res.data);
    throw new Error('Login failed: accessToken missing in response');
  }
  setSession(token);
  await hydrateCurrentUserContext(token);
}

export async function logout(): Promise<void> {
  await client.post(ep.authLogout, {}, { withCredentials: true });
}

export async function refreshToken(): Promise<string> {
  const res = await client.get(ep.authRefresh, { withCredentials: true });
  const token = res.data?.accessToken || res.data?.access_token || res.data?.token;
  if (!token) {
    throw new Error('refreshToken: accessToken missing in response');
  }
  setSession(token);
  await hydrateCurrentUserContext(token);
  return token;
}
